// People页面相关数据
// 按规则修改和添加内容即可，请不要更改数据结构以及变量命名
export const peopleData = {
    Faculty: [{
        id: 1,
        name: "林洲汉",
        pic: "./static/people/t-1.jpg",
        grade: "To explore and develop machine intelligence capable of acquiring, forming, reasoning, and interacting with abstract concepts from large amounts of data",
        homepage: "https://hantek.github.io/",
    }],
    PhD: [{
            id: 1,
            name: "亓杰星",
            pic: "./static/people/s-1.jpg",
            grade: "自然语言处理、语义解析、Text-to-SQL、Text-to-Code",
            homepage: "https://jiexingqi.github.io/",
        },
        {
            id: 2,
            name: "宋昀翀",
            pic: "./static/people/s-2.jpeg",
            grade: "图机器学习",
            homepage: "https://scholar.google.com/citations?user=C-TqDNsAAAAJ",
        },
        {
            id: 3,
            name: "曾博义",
            pic: "./static/people/s-3.jpg",
            grade: "LLMs、Model Fingerprinting、Long Sequence Modeling",
            homepage: "https://scholar.google.com/citations?user=rI5JUvgAAAAJ&hl=zh-CN",
        },
        {
            id: 4,
            name: "戴蓓亚",
            pic: "./static/people/s-4.jpg",
            grade: "NLP、LLM、Retrieval-Argument Generation",
            homepage: "https://scholar.google.com.hk/citations?hl=zh-CN&user=7BuWFrgAAAAJ&view_op=list_works&gmla=AILGF5WGdkvm9dmpFsARgp7sVd72JNqvYv7KB8-trWuqGE9K-IjxDM6RUPYdBw-GZB-CCV4Nsds_PEfSj5rgpwpvPKHNKzFK9UbK4mF4rlM",
        },
        {
            id: 5,
            name: "开聚实",
            pic: "./static/people/s-5.jpg",
            grade: "LLM、Generation",
            homepage: "https://scholar.google.com/citations?user=W85K17gAAAAJ&hl=zh-CN",
        },
        {
            id: 6,
            name: "刘一凡",
            pic: "./static/people/s-6.jpg",
            grade: "语音识别、语音生成",
            homepage: "https://github.com/PussyCat0700",
        },
        {
            id: 7,
            name: "朱学凯",
            pic: "./static/people/s-7.jpg",
            grade: "LLMs、Data-centric Scaling",
            homepage: "https://xuekai-zhu.github.io/Xuekai-Zhu/",
        },
    ],
    Master: [{
            id: 8,
            name: "黄思远",
            pic: "./static/people/s-8.jpg",
            grade: "图神经网络",
            homepage: "https://scholar.google.com/citations?user=zw-OiYcAAAAJ&amp;hl=en",
        },
        {
            id: 9,
            name: "侯晟元",
            pic: "./static/people/s-9.jpg",
            grade: "时间序列预测、文本句法分析、机器翻译",
            homepage: "https://github.com/houshengyuan",
        },
    ],
    Undergrads: [{
            id: 10,
            name: "王意轩",
            pic: "./static/people/s-10.jpg",
            grade: "多模态语音识别",
            homepage: "https://github.com/LuckySJTU",
        },
        {
            id: 11,
            name: "宋士祥",
            pic: "./static/people/s-11.jpg",
            grade: "hallucination in LLMs",
            homepage: "https://shixiangsong.github.io",
        },
        {
            id: 12,
            name: "焦旸",
            pic: "./static/people/s-12.jpg",
            grade: "AI Agent智能体框架、单调逻辑推理",
            homepage: "https://github.com/OctoberFox11",
        },
        {
            id: 13,
            name: "蔡家承",
            pic: "",
            grade: "NLP、大语言模型",
            homepage: "https://github.com/Ceslander",
        },
        {
            id: 14,
            name: "苏畅",
            pic: "./static/people/s-14.jpg",
            grade: "NLP",
            homepage: "https://github.com/shadowbringer1",
        },
        {
            id: 15,
            name: "尹晓晗",
            pic: "./static/people/s-15.jpg",
            grade: "音频降噪、多模态语音识别",
            homepage: "https://github.com/LuckySJTU",
        },
    ],
    Alumni: []
}